<hr *ngIf="includeTopDivider" class="mt-none">
<div class="action-list-header mt-24px">{{header}}</div>
<hr *ngIf="includeTopDivider" class="mt-24px">
<ng-container *ngFor="let a of actions">
  <app-action *ngIf="a.displayMe"
              [action]="a"
              (clicked)="actionClicked(a)">
  </app-action>
</ng-container>
